module.exports = __webpack_public_path__ + "media/images/billing/chatting-2c5938d8aad948973b2c0fcda52ceb2e.svg";